<template>
  <div class="menu_management">
    <div class="container">
      <el-card>
        <el-button class="colortheme" @click="addMenu">+添加</el-button>
        <el-table
          style="margin-top: 16px"
          :data="tableData"
          row-key="id"
          lazy
          :header-cell-style="cellStyle"
        >
          <el-table-column prop="code" label="ID" width="100" align="center" />
          <table-tree-column prop="authName" treeKey="id" label="名称" align="center" />
          <el-table-column prop="icon" label="图标" align="center">
            <template v-slot="{ row }">
              <i :class="row.icon || ''" class="iconfont"></i>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="类型" align="center">
            <template v-slot="{ row }">
              <el-tag v-if="row.type === '1'" size="small">目录</el-tag>
              <el-tag v-if="row.type === '2'" size="small" type="success">菜单</el-tag>
              <el-tag v-if="row.type === '3'" size="small" type="warning">按钮</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="url" label="菜单URL" align="center" />
          <el-table-column class="operation" width="100" label="操作" align="center">
            <template v-slot="{ row }">
              <div class="operation_bottom">
                <dic-button
                  permission="/admin_auth/v1/list"
                  @buttonClick="editItem(row)"
                  icon="icon-jr-icon-modify"
                  text="编辑"
                />
                <dic-button
                  permission="/admin_auth/v1/list"
                  @buttonClick="deleteItem(row)"
                  icon="icon-jr-icon-delete"
                  text="删除"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog
          ref="addVisible"
          :title="dialogType ? '编辑菜单' : '新增菜单'"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose"
          @close="handleClose"
        >
          <el-form
            ref="menuManagementObj"
            :model="menuManagementObj"
            :rules="menuManagementRules"
            label-width="120px"
          >
            <el-form-item label="菜单类型" prop="menuType">
              <el-radio-group v-model="menuManagementObj.type">
                <el-radio v-for="item in menuTypeList" :key="item.value" :label="item.value">{{
                  item.label
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="`${menuTypeList[menuName].label}名称`" prop="name">
              <el-input
                v-model="menuManagementObj.authName"
                :placeholder="`请输入${menuTypeList[menuName].label}名称`"
              />
            </el-form-item>
            <el-form-item label="上级菜单：">
              <el-select v-model="menuManagementObj.parentId" placeholder="请选择">
                <el-option
                  v-for="item in menuList"
                  :key="item.id"
                  :label="item.authName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="menuName != '2' ? '菜单URL' : '按钮权限'" prop="url">
              <el-input
                v-if="menuName != '2'"
                v-model="menuManagementObj.url"
                placeholder="请输入菜单URL"
              />
              <el-input v-else v-model="menuManagementObj.path" placeholder="请输入按钮权限" />
            </el-form-item>
            <el-form-item label="请输入类型">
              <el-input v-model="menuManagementObj.pathType" placeholder="请输入类型" />
            </el-form-item>
            <el-form-item label="菜单图标" prop="icon">
              <el-input v-model="menuManagementObj.icon" placeholder="请输入菜单icon" />
            </el-form-item>
            <div style="margin-left: 30px">菜单修改之后，重新登录才生效</div>
          </el-form>
          <div class="text-right">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 定</el-button>
          </div>
        </el-dialog>
      </el-card>
    </div>
  </div>
</template>

<script>
const defaultMenuManagementObj = Object.freeze({
  id: '', //ID
  authName: '', //名称
  icon: '', // 图标
  type: '1', // 类型
  parentName: '', // 上级菜单
  url: '', // 菜单URL
  perms: '', // 授权标识
  orderNum: '', // 排序
  parentId: '',
  pathType: ''
})
import { menuList, addMenuList, updataMenuList, detailId, deleteMenu } from '@/api/menuManagement'
import TableTreeColumn from '../../../components/TableTreeColumn.vue'
import DicButton from '../../../components/DicButton.vue'
export default {
  components: { TableTreeColumn, DicButton },
  name: 'menuManagement',
  data() {
    return {
      cellStyle: {
        background: '#F7FAF8',
        color: '#1A1F33'
      },
      tableData: [], //表格数据
      dialogType: 0, // 面板类型  0 新增 1 编辑
      dialogVisible: false, // 新增编辑的弹窗
      menuManagementObj: { ...defaultMenuManagementObj },
      menuManagementRules: {
        type: [{ required: true, message: '请选择菜单类型', trigger: 'change' }],
        authName: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }]
      },
      popupTreeProps: {
        label: 'name',
        children: 'children'
      },
      menuList: [], // 菜单
      menuTypeList: [
        { label: '目录', value: '1' },
        { label: '菜单', value: '2' },
        { label: '按钮', value: '3' }
      ]
    }
  },
  computed: {
    menuName() {
      return this.menuTypeList.findIndex((item) => {
        return item.value === this.menuManagementObj.type
      })
    }
  },
  created() {
    this.search()
  },
  methods: {
    //编辑单个菜单或者目录
    async editItem(row) {
      const { data: res } = await detailId({ id: row.id })
      console.log('123', res)
      if (res.resultCode === 200) {
        Object.assign(this.menuManagementObj, res.data)
      }

      this.dialogVisible = true

      this.dialogType = 1
    },
    // 新增
    addMenu() {
      this.dialogVisible = true

      this.dialogType = 0
    },
    //关闭弹窗
    handleClose() {
      this.$refs.menuManagementObj.resetFields()

      Object.assign(this.menuManagementObj, defaultMenuManagementObj)

      this.dialogVisible = false
    },
    //新增或者编辑
    submitForm() {
      this.$refs.menuManagementObj.validate(async (valid) => {
        if (valid) {
          if (!this.menuManagementObj.parentId) {
            this.menuManagementObj.parentId = 0
          }
          let res
          // 新增
          if (this.dialogType === 0) {
            res = await addMenuList(this.menuManagementObj)
          } else {
            res = await updataMenuList(this.menuManagementObj)
          }

          if (res.data.resultCode === 200) {
            this.$messageSuccess(`菜单${this.dialogType ? '编辑' : '新增'}成功`)
            this.search()
          } else {
            this.$message.error(res.message)
          }
          this.dialogVisible = false
        }
      })
    },
    //删除单个菜单或者目录
    deleteItem(row) {
      this.$confirm('确认删除吗 ?', '提示')
        .then(async () => {
          const { data: res } = await deleteMenu({ id: row.id })
          if (res.resultCode === 200) {
            this.$message.success('删除成功')
            this.search()
          }
        })
        .catch(() => {})
    },
    //查询
    async search() {
      const query = {
        pageNum: 0,
        pageSize: 30
      }
      const { data: res } = await menuList(query)
      if (res.resultCode === 200) {
        this.tableData = res.data.list
        this.menuList = this.tableData.filter((item) => {
          return item.type === '1'
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 80vh;
  overflow: scroll;
}
.menu_management {
  width: 100%;

  .el-table {
    /deep/tbody tr:hover > td {
      // background-color: #90c0f1;
      background-color: rgba(23, 117, 122, 0.1);
    }
  }

  /deep/ .el-table::before {
    height: 0;
  }

  /deep/ .el-table__cell {
    border: none;
  }

  /deep/ .colortheme {
    background-color: #17757a;
    color: #fff;
    border: 1px solid #17757a;
  }
}
</style>
